import create from 'zustand'
import { persist } from "zustand/middleware"
import langs from '../../lang';

const persistConfig = {
  name: "locale-storage"
};

const localeStore = create(
  persist((set, get) => {

    const getDefaultLanguage = () => {
      if (navigator?.language) {
        const [langCode, ..._] = navigator.language.split("-");
        return langCode;
      } else {
        return langs[0];
      }
    }

    const initState = {
      code: getDefaultLanguage(),
      name: null,
      messages: null,
    }

    const firstMatchedLang = (code) => {
      const [matchedLang, ..._] = langs.filter( lang => lang.code === code);
      if ( matchedLang ) {
        return matchedLang;
      }
      return null;
    }

    const setLocaleAction = (code) => {
      const lang = firstMatchedLang(code);
      if ( lang) {
        set({ 
          ...lang 
        })
        sendLanguageToNativeAction();
      }
    }

    const sendLanguageToNativeAction = () => {
      let langCode = get().code;
      window?.Native?.saveLanguage?.(langCode)
      window?.webkit?.messageHandlers.saveLanguage?.postMessage?.(langCode);
    }

    const getNameAction = () => {
      const lang = firstMatchedLang(get().code);
      if ( lang) {
        return lang.name
      }
      return null
    }

    const getMessagesAction = () => {
      const lang = firstMatchedLang(get().code);
      if ( lang) {
        return lang.messages
      }
      return null
    }

    return {
      ...initState,
      setLocale: setLocaleAction,
      getName: getNameAction,
      getMessages: getMessagesAction,
      sendLanguageToNative: sendLanguageToNativeAction,
    }
  }, persistConfig  
));

export default localeStore;